export default __webpack_public_path__ + "static/hkCta-77b7fca6ef22490ea5170b594d27ddd9.png";